module.exports = __webpack_public_path__ + "img/tu4.836810f7.png";